// import axios from "axios";
import Cookies from "js-cookie";
import { Tools, axios } from "../config";
import { effeative, maxPageSize } from "./common_logic";

export class GradeLogic {
    async selData(classId: string) {
        const r = effeative(await axios({
            method: "GET",
            url: Tools.getApiAddress("menber_grade_look"),
            params: {
                classId
            },
            headers: {
                SYSTOKEN: Cookies.get("token"),'ClientSource':'web'
            },
        }))
        return r.data.data;
    }
    async querysList(param) {
        const r = effeative(await axios({
            method: "POST",
            url: Tools.getApiAddress("menber_grade_page"),
            data: param,
            headers: {
                SYSTOKEN: Cookies.get("token"),'ClientSource':'web'
            },
        }))
        return r;
    }
    
    async gradeList() {
        const r = effeative(await axios({
            method: "POST",
            url: Tools.getApiAddress("menber_grade_page"),
            data: {
                gradeName: '',
                pageIndex: 1,
                pageSize: maxPageSize(),
                orderBy: '',
                sort: ''
            },
            headers: {
                SYSTOKEN: Cookies.get("token"),'ClientSource':'web'
            },
        }))
        return r.data.data.dataSource || [];
    }
    async addData(params) {

        return effeative(await axios({
            method: "POST",
            url: Tools.getApiAddress("menber_grade_add"),
            data: params,
            headers: {
                SYSTOKEN: Cookies.get("token"),'ClientSource':'web'
            },
        }))

    }
    async updData(params) {
        return effeative(await axios({
            method: "POST",
            url: Tools.getApiAddress("menber_grade_update"),
            data: params,
            headers: {
                SYSTOKEN: Cookies.get("token"),'ClientSource':'web'
            },
        }))

    }

}